import React from 'react';
import { Link } from 'react-router-dom';
import ResetLocation from "../../helpers/ResetLocation";

const MenuGridItem = ({ singleProduct }) => {
  // const [setSelectedAttributes] = useState([]);
  // const [setTargetAttribute] = useState('');

  // const handleSelectedAttributes = (attributeId, attributeValue) => {
  //   setTargetAttribute(attributeValue);
  //   const newSelectedAttribute = { attributeId, attributeValue };
  //   setSelectedAttributes(prevAttributes => {
  //     const existingAttributeIndex = prevAttributes.findIndex(
  //       attribute => attribute.attributeId === newSelectedAttribute.attributeId
  //     );
  //     if (existingAttributeIndex !== -1) {
  //       const updatedAttributes = [...prevAttributes];
  //       updatedAttributes[existingAttributeIndex] = { ...newSelectedAttribute };
  //       return updatedAttributes;
  //     } else {
  //       return [...prevAttributes, newSelectedAttribute];
  //     }
  //   });
  // };


  return (
    <article className="menu-item txt-white">
      <Link onClick={ResetLocation} to={`/menu/${singleProduct.id}`} className="menu-item__link">
        <img src={singleProduct.ItemImg} alt={`${singleProduct.ItemName}`} />
      </Link>
      <h3>{singleProduct.ItemName}</h3>
      <p>{singleProduct.ItemIngredients}</p>
      <div className="menu-item__pricing">
        {singleProduct.sale === true ?
          <section className="menu-item__pricing-sale">
            <p className="menu-item__pricing-prev"><span>€</span>{singleProduct.ItemPriceBefore}</p>
            <p className="menu-item__pricing-curr"><span>€</span>{singleProduct.ItemPrice}</p>
          </section>
          :
          <p className="menu-item__pricing-curr"><span>€</span>{singleProduct.ItemPrice}</p>
        }
      </div>
    </article>
  );
};

export default MenuGridItem;
